
import PropTypes from "prop-types";
import SoftBox from "components/SoftBox";
import { Grid, Slider, ThemeProvider } from "@mui/material";
import { createTheme } from '@mui/material/styles';
import SoftTypography from "components/SoftTypography";
import LatestCameraImage from "../LatestCameraImage";
import SoftButton from "components/SoftButton";
import { useAuth0 } from "@auth0/auth0-react";
import crowdCountingAPI from "../../api/crowd_counting";
import { useState } from "react";
import Swal from "sweetalert2";

const sliderTheme = createTheme({
    palette: {
        primary: {
            light: '#757ce8',
            main: '#3f50b5',
            dark: '#002884',
            contrastText: '#fff',
        },
        secondary: {
            light: '#ff7961',
            main: '#f44336',
            dark: '#ba000d',
            contrastText: '#000',
        },
    },
});

const MAX_MULTIPLIER = 10;

var marks = [];
const STEPS = 10;

for (let i = 0; i <= STEPS; i++) {
    if (i == 0) {
        marks.push({
            value: 1,
            label: String(1)
        });
    }
    else {
        marks.push({
            value: (MAX_MULTIPLIER / STEPS) * i,
            label: String((MAX_MULTIPLIER / STEPS) * i)
        });
    }
}


function FudgeSliders({ device, multiplier }) {
    crowdCountingAPI.loadToken(useAuth0());

    const [fudgeFactor, setFudgeFactor] = useState(multiplier);

    const triggerSubmit = (location) => {
        location.multiplier = fudgeFactor;
        console.log(fudgeFactor)

        crowdCountingAPI.updateCameraLocationData(location);

        Swal.fire({
            icon: "success",
            title: `${device.name} saved.`,
            showConfirmButton: false,
            timer: 1500
        });
    }

    const handleChange = (e, newValue) => {
        setFudgeFactor(newValue);
    }

    function valueLabelFormat(value) {
        return value;
    }

    return (
        <SoftBox>
            <SoftBox sx={{ height: "26vh", width: "100%" }} mb={5}>
                <SoftBox sx={{ height: "100%" }}>
                    <Grid container sx={{ height: "100%" }}>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ height: "100%" }}>
                            <SoftBox sx={{ 'object-fit': "contain", textAlign: 'center', height: "100%", width: "100%" }} >
                                <LatestCameraImage device_uuid={device.uuid} />
                            </SoftBox>
                        </Grid>
                    </Grid>
                </SoftBox>
            </SoftBox>
            <SoftBox display="flex" flexDirection="column" alignItems="center" justifyContent="center" mt={3}>
                <SoftBox display="flex" flexDirection="column" justifyContent="center" alignItems="center" sx={{ width: "80%" }}>
                    <SoftBox display="flex" flexDirection="column" justifyContent="center" alignItems="center">
                        <SoftTypography variant="h4">{device.name}</SoftTypography>
                        <SoftTypography variant="h5">{device.uuid}</SoftTypography>
                    </SoftBox>
                    <ThemeProvider theme={sliderTheme}>
                        <Slider color="primary" value={fudgeFactor} marks={marks} valueLabelDisplay="on" getAriaValueText={valueLabelFormat} valueLabelFormat={valueLabelFormat} onChange={handleChange} min={1} max={MAX_MULTIPLIER} step={0.1} />
                    </ThemeProvider>
                    <SoftBox mt={2}>
                        <SoftButton variant="gradient" color="warning" size="small" onClick={() => { triggerSubmit(device.location) }}>UPDATE</SoftButton>
                    </SoftBox>
                </SoftBox>
            </SoftBox>

        </SoftBox >
    );
}

FudgeSliders.propTypes = {
    device: PropTypes.object,
    multiplier: PropTypes.number,
    current_camera_img: PropTypes.string,
}

export default FudgeSliders;